
import * as _ from 'lodash'
import * as moment from 'moment'
import {isEmpty} from "rxjs/operator/isEmpty";

export interface IExecutionSerializerRunOptions {
  bSkipDebounce?: boolean,
  sReason?: string
}

const ExecutionSerializerOptionDefaults : IExecutionSerializerRunOptions = {
  bSkipDebounce: false
}

export class ExecutionSerializer {

  private ExecContext: any
  private ExecFunction: () => Promise<any>
  private ExecArguments: any[]

  private Executing: boolean
  private Queued: boolean
  private DebounceTimeoutms: number
  private ExecPromise: Promise<any>

  private bDebug: boolean
  private name: string
  private dctReason: {[id:string]: number}

  // Stats
  private runCount: number
  private deboundCount: number
  private deboundCountTotal: number

  constructor(ctx: any, func: () => Promise<any>, args: any[], debounceTimeout: number = 2000, pDebug: boolean = false){
    this.Executing = false
    this.Queued = false
    this.DebounceTimeoutms = debounceTimeout
    this.ExecPromise = undefined
    this.ExecContext = ctx
    this.ExecFunction = func
    this.ExecArguments = args
    this.bDebug = pDebug
    this.name = (<any>func).name || ''
    this.runCount = 0
    this.deboundCount = 0
    this.deboundCountTotal = 0
    this.dctReason = {}
  }

  get Name(): string { return this.name }
  set Name(value) { this.name = value }

  Reset() {
    this.Executing  = false
    this.Queued = false
    this.ExecPromise = undefined
  }

  Run(options?: IExecutionSerializerRunOptions) {
    const self = this
    let opts: IExecutionSerializerRunOptions = {}
    _.defaults(opts, options, ExecutionSerializerOptionDefaults)

    // Check if Executing
    if(self.Executing) {
      self.Queued = true
      self.deboundCount += 1
      self.deboundCountTotal += 1
      if(!_.isEmpty(opts.sReason)) {
        if(opts.sReason in self.dctReason) {
          self.dctReason[opts.sReason] += 1
        } else {
          self.dctReason[opts.sReason] = 1
        }
      }
      return
    }

    self.Executing = true

    // Give Debound time before firing calc
    setTimeout(function(){
      //if(!_.isEmpty(self.ExecPromise)){
      //  return // someone has started the function already
      //}
      self.runCount += 1

      self.Queued = false
      let startTime = moment.now()
      if(self.bDebug){
        console.log(self.Name, " executing..", ((self.deboundCount > 0)? " debounced: " + self.deboundCount:""))
        if(!_.isEmpty(self.dctReason)){
          console.log(self.Name, " execution reasons..", self.dctReason)
        }
      }
      self.deboundCount = 0
      self.dctReason = {}
      self.ExecPromise = self.ExecFunction.apply(self.ExecContext, self.ExecArguments)
        .then((ignore: any) => {
          //
          self.Executing = false
          self.ExecPromise = undefined
          if(self.bDebug){
            let endTime = moment.now()
            let ms = moment.duration(endTime - startTime).asMilliseconds()
            console.log(self.Name, " executed successfully. ", ((self.Queued)? "Queued. ":""), ms.toString() , "ms")
          }
          if(self.Queued) {
            self.Run(opts)  // same options ?
          }
        }).catch((err:any) => {
          //
          self.Executing = false
          self.ExecPromise = undefined
        })
    }, ((opts.bSkipDebounce)? 0 : self.DebounceTimeoutms))

  }


}